import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AirlineSeatFlatAngledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"airline_seat_flat_angled"}/>
}
